// extracted by mini-css-extract-plugin
export default {"page":"Privacy_page__3Kj63","title":"Privacy_title__r8Od-","updated":"Privacy_updated__NHTNa"};